<template>
    <div class="overflow-x-hidden">
        <section class="text-center grid flex flex-wrap justify-content-center align-items-center py-4 px-4 md:px-6">
            <div class="col-10 py-4">
                <span class="badge mb-2">Tutors</span>
                <h2 class="mb-2 LandingPage-Title">
                    Share Your Knowledge, Shape Sri Lanka’s Future.
                </h2>
                <p class="Paragraph-Regular  mx-auto">
                    Teach what you love. Earn what you deserve
                </p>
            </div>
            <div class="grid align-items-start justify-content-center">
                <div class="col-12 lg:col-6 flex justify-content-start md:px-6 pt-5">
                    <img :src="bgUrl" alt="Tutor teaching students"
                        class="w-full border-round-xl shadow-2" />
                </div>
                <div class="col-12 lg:col-5">
                    <div class="grid">
                        <div v-for="(step, index) in steps" :key="index" class="col-12">
                            <div class="flex flex-row align-items-center gap-3 p-1">
                                <div class="flex-shrink-0 ">
                                    <div
                                        class="step-number w-3rem h-3rem flex align-items-center justify-content-center Paragraph-Medium ">
                                        0{{ index + 1 }}
                                    </div>
                                </div>
                                <div class="">
                                    <p class="Paragraph-Medium mb-1 text-left ">{{ step.title }}
                                    </p>
                                    <p class="text-left Label mb-0 leading-relaxed">{{ step.description }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 md:flex md:flex-wrap p-3">
                        <Button label="Create a tutor profile" icon="pi pi-arrow-right" iconPos="right"
                            class="community-button " @click="tutorSignUp('/tutorOnBoarding', 'tutor')" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import Button from 'primevue/button';
import { usePublicUrl } from "@/utils/getPublicUrl"
import { useRouter } from 'vue-router'
import { useAuthStore } from "@/stores/authStore";

const router = useRouter()
const authStore = useAuthStore()
const bgUrl = usePublicUrl("public/knowledge.jpg");
const steps = [
    {
        title: "Create Your Tutor Profile",
        description: "Highlight your teaching experience, subjects, and unique strengths."
    },
    {
        title: "Get Verified",
        description: "Submit your details for a quick verification to build trust with students and parents."
    },
    {
        title: "Set Your Schedule & Rates",
        description: "Choose when you want to teach and how much you want to charge — full flexibility."
    },
    {
        title: "Start Connecting With Students",
        description: "Begin receiving class requests, teach online or in person, and earn on your schedule."
    }
];

const tutorSignUp = (url, type) => {
  authStore.setUserType(type)
  router.push(url)
}

</script>
<style scoped>
.step-number {
    background-color: #E4F6F0;
    border-radius: 8px
}
</style>